module.exports = __webpack_public_path__ + "img/icon-vendidos.c3b4ad6a.svg";